module.exports = __webpack_public_path__ + "static/media/willo-intelligence.d1f8c19b.png";